import { useMemo } from 'react'

import { actions } from '../../../../redux'
import { FullDeclaration, MemberProps, MemberReturn } from '../../../../types'

export const useRegistrant = (props: MemberProps): MemberReturn => {
  const { t, dispatch, formValues, fullName } = props

  const declarations = useMemo(() => (formValues?.items as FullDeclaration[]) || [], [formValues])

  const handleAddDeclaration = (values: any) => {
    dispatch(
      actions.declaration.appendNewDeclarationItem({
        ...values,
        id: declarations.length,
      })
    )
  }

  const handleUpdateDeclaration = (i: number, values: any) => {
    dispatch(
      actions.declaration.updateDeclarationItem({
        index: i,
        item: values,
      })
    )
  }

  const handleDeleteDeclaration = (i: number) => {
    dispatch(actions.declaration.removeDeclarationItem(i))
  }

  const handleResetDeclaration = () => {
    dispatch(actions.declaration.resetDeclarations())
  }

  return {
    declarations,
    addDeclaration: handleAddDeclaration,
    updateDeclaration: handleUpdateDeclaration,
    deleteDeclaration: handleDeleteDeclaration,
    addMember: () => undefined,
    resetMember: handleResetDeclaration,
    addMemberInitialValues: {
      hasMemberToDeclare: '0',
      civility: '',
      lastName: '',
      firstName: '',
    },
    addAnotherChild: {},
    addDeclarationStepPartText: t('declaration.form.stepPart.myDeclaration'),
    addDeclarationLabel: t('declaration.form.addDeclaration.label'),
    declarationListStepPartText: t('declaration.form.stepPart.myDeclaration'),
    declarationListLabel: t('declaration.form.declarationList.label', {
      name: fullName,
      type: t('declaration.registrant'),
    }),
    addMemberStepPartText: '',
    addMemberLabel: '',
    typeOfAdd: 'registrant',
  }
}
